import React, { memo } from 'react';
import Icon from '../AppIcon';
import Button from '../ui/Button';

const ArrayInput = memo(({ label, arrayName, items, newValue, onValueChange, onAdd, onRemove, placeholder }) => {
  const handleInputChange = (e) => {
    onValueChange(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onAdd();
    }
  };

  const handleAddClick = () => {
    onAdd();
  };

  return (
    <div>
      <label className="block text-sm font-medium text-foreground mb-2">{label}</label>
      <div className="space-y-2">
        <div className="flex space-x-2">
          <input
            type="text"
            value={newValue}
            onChange={handleInputChange}
            placeholder={placeholder}
            className="flex-1 px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
            onKeyPress={handleKeyPress}
          />
          <Button
            type="button"
            variant="outline"
            onClick={handleAddClick}
          >
            <Icon name="Plus" size={16} />
          </Button>
        </div>
        
        {items.length > 0 && (
          <div className="space-y-1">
            {items.map((item, index) => (
              <div key={`${arrayName}-${item}-${index}`} className="flex items-center justify-between bg-muted/50 px-3 py-2 rounded">
                <span className="text-sm">{item}</span>
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  onClick={() => onRemove(index)}
                  className="text-red-600 hover:text-red-700"
                >
                  <Icon name="X" size={14} />
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
});

ArrayInput.displayName = 'ArrayInput';

export default ArrayInput;